export default __webpack_public_path__ + "static/media/destroyed_38@2x.069975a1.png";